import { FC } from "react";
import { dailyRate, formatPrice, getEnabledPeriodPrices, markupPercent } from "@1-now/booking-core";
import { useData } from "data/data-provider";
import { badgePercent, isNotBookable, isPriceOnRequest } from "utils/carPrice";
import RequestPriceButton from "shared/RequestPriceButton/RequestPriceButton";

/**
 * The price a panel shows: the daily rate the card shows and the crossed-out was-price when the
 * card shows one. Not bookable: why not, in words. The deposit is said in the booking steps, not
 * here (Taha, 8 Oct).
 */
export const CarPrice: FC<{ car: any }> = ({ car }) => {
  const { ourCompany } = useData();
  if (isNotBookable(car)) {
    return (
      <div className="db-xp-price">
        <span className="db-xp-price__none">{isPriceOnRequest(car) ? "Price on request" : "Price coming soon"}</span>
      </div>
    );
  }
  const primary = getEnabledPeriodPrices(dailyRate(car) ?? 0, ourCompany, car?.period_prices)[0];
  const was = badgePercent(markupPercent(car)) != null ? Number(car?.increased_price) : null;
  return (
    <div className="db-xp-price">
      <div className="db-xp-price__row">
        {was != null && <span className="db-xp-price__was">${formatPrice(was)}</span>}
        <span className="db-xp-price__amt">
          {primary.formatted}
          <small>{primary.label}</small>
        </span>
      </div>
    </div>
  );
};

/**
 * The panel's one action: Book now, the Request price action for a car priced on request, nothing
 * for a car with no price yet (its price line says so).
 */
export const CarCta: FC<{ car: any; onBook: () => void }> = ({ car, onBook }) => {
  if (isPriceOnRequest(car)) return <RequestPriceButton car={car} className="db-btn db-btn--primary db-xp-cta" />;
  if (isNotBookable(car)) return null;
  return (
    <button type="button" className="db-btn db-btn--primary db-xp-cta" onClick={onBook}>
      Book now
    </button>
  );
};

